const TAGS = {
  NEW: "new",
  TOP: "top",
  JACKPOT: "jackpot",
  SLOT: "slot",
  NONSLOT: "nonslot"
};

const SORT = {
  POPULARITY: "popularity",
  ALPHABETICALLY: "alphabetically"
};

export const SLOTS_FILTER = {
  SORT,

  TAGS,

  SORT_OPTIONS: [SORT.POPULARITY, SORT.ALPHABETICALLY],
  
  FILTER_OPTIONS: [
    { name: "all games", value: undefined },
    { name: "new", value: TAGS.NEW },
    { name: "top", value: TAGS.TOP },
    { name: "table", value: TAGS.NONSLOT },
    { name: "fruits", value: TAGS.JACKPOT }
  ]
}



// WEBPACK FOOTER //
// ./skins/xkiosk/components/games-filter/slots.const.js